module.exports = __webpack_public_path__ + "assets/img/info-btn-c985ce86.png";